import { writable } from "svelte/store";

export const showLimitRoomModalStore = writable(false);
export const showShareLinkMapModalStore = writable(false);
